import { useEffect, useState, useContext, useRef } from 'react'
//Context
import { ItinerariesContext } from '../../context/ItinerariesProvider'
import { I18nContext } from '../../context/I18nProvider'
//Libs
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Translate from '../../i18n/Translate'
import Select, { components } from 'react-select'
//Components
import ShortArrow from '../svg/ShortArrow'
import { SpinnerEllipsis } from '../../components/Spinners'
//Helpers
import { writeSearch } from '../../helpers'

/*
    @param {string} background
        - 'bg-dark'
        - 'bg-light'
    Para cambiar el color del fondo y textos del componente 
*/

const DestinationFilter = ({ background = 'bg-dark', handleCloseFilterPanel }) => {
    const { t } = useTranslation()
    const history = useHistory()

    const { language } = useContext(I18nContext)
    const { itinerariesOptions, contextSelectedOptions } = useContext(ItinerariesContext)
    const experienceRef = useRef(null)
    const travelRef = useRef(null)
    const destinationRef = useRef(null)

    const [selectedDestination, setSelectedDestination] = useState('')
    const [selectedTravel, setSelectedTravel] = useState('')
    const [selectedExperience, setSelectedExperience] = useState('')

    const [destinationsOptions, setDestinationsOptions] = useState([])
    const [travelOptions, setTravelOptions] = useState([])
    const [experiencesOptions, setExperiencesOptions] = useState([])

    useEffect(() => {
        if (
            itinerariesOptions.destinations.length !== 0 &&
            itinerariesOptions.types_of_travels.length !== 0 &&
            itinerariesOptions.types_of_experiences.length !== 0
        ) {
            const destinationsFormatted = itinerariesOptions.destinations.map((destination) => ({
                value: destination,
                label: destination,
            }))
            const travelOptionsFormatted = itinerariesOptions.types_of_travels.map((travel) => ({
                value: travel,
                label: travel,
            }))
            const experiencesFormatted = itinerariesOptions.types_of_experiences.map((experience) => ({
                value: experience,
                label: experience,
            }))
            setDestinationsOptions(destinationsFormatted)
            setTravelOptions(travelOptionsFormatted)
            setExperiencesOptions(experiencesFormatted)
        }
    }, [itinerariesOptions])

    //Veo si hay opciones ya seleccionadas en el contexto y la cargo en el Select
    useEffect(() => {
        if (
            contextSelectedOptions.destination !== '' ||
            contextSelectedOptions.type_of_experience !== '' ||
            contextSelectedOptions.type_of_travel !== ''
        ) {
            setSelectedDestination(contextSelectedOptions.destination)
            setSelectedTravel(contextSelectedOptions.type_of_travel)
            setSelectedExperience(contextSelectedOptions.type_of_experience)
        }
    }, [contextSelectedOptions])

    const handleDestinationChange = (selectedOption) => setSelectedDestination(selectedOption.value)

    const handleTravelChange = (selectedOption) => setSelectedTravel(selectedOption.value)

    const handleExperienceChange = (selectedOption) => setSelectedExperience(selectedOption.value)

    const handleSubmit = (e) => {
        e.preventDefault()

        if (!selectedDestination && !selectedExperience && !selectedTravel) {
            //Si no hay ningun Select seleccionado entonces setea el foco al primer input
            destinationRef.current.select.focus()

            return
        } else {
            // console.table({ selectedDestination, selectedTravel, selectedExperience, language })
            // console.log(writeSearch(selectedDestination, selectedTravel, selectedExperience))

            history.replace({
                pathname: `/${language}${t('routes.itineraries')}`,
                search: writeSearch(selectedDestination, selectedTravel, selectedExperience),
            })

            //Cierro el panel de filtros
            handleCloseFilterPanel && handleCloseFilterPanel()
        }
    }
    const handleReset = () => {
        setSelectedDestination('')
        setSelectedTravel('')
        setSelectedExperience('')

        history.replace({
            pathname: `/${language}${t('routes.itineraries')}`,
            search: '',
        })
    }

    // Para cambiar el svg del indicador del select
    const IndicatorsContainer = (props) => (
        <components.DropdownIndicator {...props}>
            <ShortArrow width={20} height={20} />
        </components.DropdownIndicator>
    )

    const LoadingMessage = (props) => (
        <components.LoadingMessage {...props}>
            <SpinnerEllipsis />
        </components.LoadingMessage>
    )

    return (
        <div className="destination-filter">
            <h3 className={`destination-filter__title ${background}`}>
                <Translate langkey="global_components.destination_filter.title" />
            </h3>

            <form className={`destination-filter__form ${background}`} onSubmit={handleSubmit}>
                <Select
                    options={destinationsOptions}
                    value={selectedDestination ? { value: selectedDestination, label: selectedDestination } : null}
                    isLoading={destinationsOptions.length === 0}
                    isSearchable={false}
                    onChange={handleDestinationChange}
                    components={{ IndicatorsContainer, LoadingMessage }}
                    className="filter-select"
                    classNamePrefix="filter-select"
                    placeholder={t('global_components.destination_filter.destination_placeholder')}
                    ref={destinationRef}
                    hideSelectedOptions
                />
                <Select
                    options={travelOptions}
                    value={selectedTravel ? { value: selectedTravel, label: selectedTravel } : null}
                    isLoading={travelOptions.length === 0}
                    isSearchable={false}
                    onChange={handleTravelChange}
                    components={{ IndicatorsContainer, LoadingMessage }}
                    className="filter-select"
                    classNamePrefix="filter-select"
                    placeholder={t('global_components.destination_filter.travel_placeholder')}
                    ref={travelRef}
                    hideSelectedOptions
                />
                <Select
                    options={experiencesOptions}
                    value={selectedExperience ? { value: selectedExperience, label: selectedExperience } : null}
                    isLoading={experiencesOptions.length === 0}
                    isSearchable={false}
                    onChange={handleExperienceChange}
                    components={{ IndicatorsContainer, LoadingMessage }}
                    className="filter-select"
                    classNamePrefix="filter-select"
                    placeholder={t('global_components.destination_filter.experience_placeholder')}
                    ref={experienceRef}
                    hideSelectedOptions
                />
                <div className="buttons-wrapper">
                    <button className="reset-btn btn" type="reset" onClick={handleReset}>
                        <Translate langkey="global_components.destination_filter.reset_button" />
                    </button>
                    <button className="apply-btn btn" type="submit">
                        <Translate langkey="global_components.destination_filter.apply_button" />
                    </button>
                </div>
            </form>
        </div>
    )
}

export default DestinationFilter
